import { applyColorScheme as applyThemeScheme } from '@platform/theme/applyColorScheme';

/**
 * Сумісний вхід для наявних викликів (App, профіль, useServerPreferences): застосовує одну з 50 схем v4 через @platform/theme
 * (<html data-scheme data-mode>, резерв у localStorage). Новий код імпортує applyColorScheme / useColorScheme з '@platform/theme'.
 */
export function applyColorScheme(scheme: string): void {
  applyThemeScheme(scheme);
}
